// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import ProofDetailsActionTypes from './proof-details.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	addBusinessProofResponse: null,
	fetchBusinessProofResponse: null,
	fetchBusinessProofList: [],
	updateBusinessProofResponse: null,
	deleteBusinessProofResponse: null,
};

// BUSINESS PROOF DETAILS REDUCER - START
const businessProofDetailsReducer: any = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD BUSINESS PROOF START *********************** */
		case ProofDetailsActionTypes.ADD_BUSINESS_PROOF_SUCCESS:
			return { ...state, addBusinessProofResponse: action.payload };

		case ProofDetailsActionTypes.ADD_BUSINESS_PROOF_FAILURE:
			return { ...state, addBusinessProofResponse: action.payload };

		case ProofDetailsActionTypes.ADD_BUSINESS_PROOF_RESPONSE_CHANGED:
			return { ...state, addBusinessProofResponse: null };
		/** ***************** ADD BUSINESS PROOF END *********************** */

		/** ***************** UPDATE BUSINESS PROOF START *********************** */
		case ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_SUCCESS:
			return { ...state, updateBusinessProofResponse: action.payload };

		case ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_FAILURE:
			return { ...state, updateBusinessProofResponse: action.payload };

		case ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_RESPONSE_CHANGED:
			return { ...state, updateBusinessProofResponse: null };
		/** ***************** UPDATE BUSINESS PROOF END *********************** */

		/** ***************** FETCH BUSINESS PROOF START *********************** */
		case ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_SUCCESS:
			return {
				...state,
				fetchBusinessProofResponse: action.payload,
				fetchBusinessProofList: docodeHexResponse(action.payload, 'GetBusinessProofKey'),
			};

		case ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_FAILURE:
			return { ...state, fetchBusinessProofResponse: action.payload };

		case ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_RESPONSE_CHANGED:
			return { ...state, fetchBusinessProofResponse: null };
		/** ***************** FETCH BUSINESS PROOF END *********************** */

		/** ***************** DELETE BUSINESS PROOF START *********************** */
		case ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_SUCCESS:
			return { ...state, deleteBusinessProofResponse: action.payload };

		case ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_FAILURE:
			return { ...state, deleteBusinessProofResponse: action.payload };

		case ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_RESPONSE_CHANGED:
			return { ...state, deleteBusinessProofResponse: null };
		/** ***************** DELETE BUSINESS PROOF END *********************** */

		default:
			return state;
	}
};
// BUSINES PROOF DETAILS REDUCER - END
export default businessProofDetailsReducer;
